const state = () => ({
    apis: [],
    api: {
        name: '',
        description: '',
        basePath: '',
        version: '',
        approval: false,
        relatedCategories: [],
        image: undefined,
        typeImage: '',
        detailedDescription: '',
        benefits: '',
        target: "Bancos",
        provider: 0,
        keyword: [],
        subscriptions: [],
        commentaries: [],
        endpointsApi: [],
        groupsApi: [],
        plansApi: [],
        dataSwagger: '',
        providerKey: ''
    },
    swaggerDados: {
        id: null,
        apiId: null,
        formatoApi: 'rest',
        tipoAnexo: 'link',
        tipoSwagger: 'json',
        link: '',
        dataSwagger: {}
    },
    chartLoanding: false,
    chartList: [],
    chart: {
        typeChart: '',
        titleGraph: '',
        chartId: '',
        datasetIdKey: '',
        chartData: {
            labels: [],
            datasets: [
                {
                    label: '',
                    backgroundColor: [],
                    data: []
                }
            ]
        }
    },
    materiaisUteis: null,
    businessModelType: '',
    formHasChanged: false,
    materiaisUteisHasChanged: false,
    registerApiTab: 0,
    recentlyChangedApi: false,
    apiDetailsLoading: false,
});
export default state;
